enum MutationNames {
  FETCH_ACCOUNT_DETAILS_BY_SLUG_FAILED = 'FETCH_ACCOUNT_DETAILS_BY_SLUG_FAILED',
  FETCH_ACCOUNT_DETAILS_BY_SLUG_REQUESTED = 'FETCH_ACCOUNT_DETAILS_BY_SLUG_REQUESTED',
  FETCH_USER_DETAILS_FAILED = 'FETCH_USER_DETAILS_FAILED',
  FETCH_USER_DETAILS_REQUESTED = 'FETCH_USER_DETAILS_REQUESTED',
  RESET_INITIAL_ACCOUNT_DETAILS_BY_SLUG_FETCH = 'RESET_INITIAL_ACCOUNT_DETAILS_BY_SLUG_FETCH',
  RESET_INITIAL_USER_DETAILS_FETCH = 'RESET_INITIAL_USER_DETAILS_FETCH',
  UPDATE_ACCCOUNT_PAYMENT_ONBOARDING_STATUS = 'UPDATE_ACCCOUNT_PAYMENT_ONBOARDING_STATUS'
}

export default MutationNames;